<script lang="ts">
    import Vue from "vue";
    import Component from 'vue-class-component';
    import { CriterionCreatorViewModel } from "@Criteria/Hierarchies/Components/CriterionCreator";

    @Component({
        props: {
            viewModel: {
                type: Object,
                required: true
            }
        }
    })
    export default class CriterionCreator extends Vue
    {
        get vm(): CriterionCreatorViewModel { return this.$props.viewModel as CriterionCreatorViewModel; }
        get opened(): boolean { return this.vm?.opened ?? false; }

        get parentId(): number { return this.vm.parentId; }
        get parentName(): string { return this.vm.parentName; }

        emitCreateCriterion()
        {
            this.vm.clearValidationErrors();
            this.$emit("create-criterion", this.parentId, this.vm.name, this.vm.description);
        }

        close()
        {
            this.vm.close();
        }
    }
</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Create under: {{parentName}}</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>
                    <div class="modal-body">
                        <form id="criterion-creator-form" @submit.prevent="emitCreateCriterion">
                            <div class="form-group">
                                <label>Name <span style="color: red;">*</span></label>
                                <input v-model.trim="vm.name" type="text" class="form-control" required maxlength="100" minlength="2">
                                <div class="error">{{vm.nameError}}</div>
                            </div>

                            <div class="form-group">
                                <label>Description</label>
                                <textarea v-model.trim="vm.description" class="form-control"></textarea>
                            </div>
                        </form>
                    </div>

                    <div class="modal-footer">
                        <button type="button" @click="close" class="btn btn-outline-secondary">Cancel</button>
                        <button type="submit" form="criterion-creator-form" class="btn btn-primary">Create</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
</style>